module.exports = __webpack_public_path__ + "static/media/snapcounterv3.02603e37.png";